export const SAMSARA_BASE_URL =
  "https://cloud.eu.samsara.com/o/562949953425970/fleet/dispatch/v2/route"

export function getSamsaraRouteUrl(routeId: string): string {
  return `${SAMSARA_BASE_URL}/${routeId}`
}
